module.exports = __webpack_public_path__ + "static/media/icon-checkmark-black.0b055b82.svg";